// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const familiaPiezaFullfilledReducer = makeSetReducer(['familia_piezas/fullfilled']);
